<template>
	<v-sheet color="transparent">
		<v-list>
			<v-list-group v-for="(part, pi) in settings.parts" :key="part.id">
				<template v-slot:activator>
					<v-list-item-title>{{part.name}}</v-list-item-title>
					<v-list-item-subtitle>{{part.description}}</v-list-item-subtitle>
				</template>
				<template v-slot:appendIcon>
					<v-progress-circular :value="partAverage(pi)" :size="50" color="green">
						{{partAverage(pi)}}
					</v-progress-circular>
				</template>
				<template v-slot:prependIcon>
					<v-list-item-icon>
						<AssessmentNavigationItemIcon :part="pi"></AssessmentNavigationItemIcon>
					</v-list-item-icon>
				</template>
				<v-list-item class="ml-6" v-for="(section, si) in part.sections" :key="section.id">
					<v-list-item-icon>				
						<AssessmentNavigationItemIcon :part="pi" :section="si"></AssessmentNavigationItemIcon>
					</v-list-item-icon>
					<v-list-item-content>					
						<v-list-item-title @click="click(pi, si)">{{section.name}}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
					</v-list-item-action>
					<v-list-item-icon>	
						<v-progress-circular :value="sectionAverage(pi, si)" :size="50" color="green">
							{{sectionAverage(pi, si)}}
						</v-progress-circular>
					</v-list-item-icon>
				</v-list-item>
			</v-list-group>
		</v-list>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import AssessmentNavigationItemIcon from "@/components/elements/AssessmentNavigationItemIcon"
	export default {
		name: "AssessmentOverview", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		components: {
			AssessmentNavigationItemIcon
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				assessments: state => state.assessments || [],
				settings: state => state.assessmentSettings || {parts: []}, 
				surveys: state => state.surveys || [], 
			}),
			assessment(){
				return this.assessments[0]
			},	
		},
		watch: {
			settings: {
				deep: true,
				immediate: true,
				handler(newValue, oldValue ){
					if( newValue && !oldValue ){
						if( this.$store.hasModule("assessmentSettings")  ){
							this.$store.dispatch("assessmentSettings/getSettings").then( ( ) => {
							})
						}
						if( this.$store.hasModule("surveys")  ){
							this.$store.dispatch("surveys/getAll").then( ( ) => {
							})
						}
					}
					
				}
			}
		},
		methods: {
			partAverage(part){
				var array = this.assessment.responses.filter( a => a.part == part );
				array = array.map( a => a.completion_rate);
				if( array.length == 0 ){
					return 0;
				}
				return this.average(array)
			},
			sectionAverage(part, section){
				var array = this.assessment.responses.filter( a => a.part == part && a.section == section );
				array = array.map( a => a.completion_rate);
				if( array.length == 0 ){
					return 0;
				}
				return this.average(array)
			},
			click(part, section){
				this.$store.commit("assessments/SET_SECTION", {part: part, section: section});
				this.$router.push("assessment")
			}

		}
		// created(){
			
		// }

	}
</script>